var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBook = function SvgBook(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.99188C0 1.96885 0 1.45734 0.211006 1.10279C0.39602 0.791917 0.68715 0.55838 1.03076 0.44521C1.42263 0.316141 1.92197 0.427104 2.92063 0.64903L7.95873 1.76861C8.34731 1.85496 8.5416 1.89813 8.73793 1.91535C8.91231 1.93064 9.08769 1.93064 9.26207 1.91535C9.4584 1.89813 9.65269 1.85496 10.0413 1.76861L15.0794 0.649029C16.078 0.427104 16.5774 0.316141 16.9692 0.44521C17.3128 0.55838 17.604 0.791917 17.789 1.10279C18 1.45734 18 1.96885 18 2.99188V12.4331C18 13.349 18 13.807 17.8377 14.1849C17.6945 14.5182 17.4634 14.8063 17.1691 15.0184C16.8354 15.2588 16.3883 15.3582 15.4942 15.5568L10.3884 16.6915C9.87025 16.8066 9.6112 16.8642 9.34942 16.8871C9.11692 16.9075 8.88308 16.9075 8.65058 16.8871C8.3888 16.8642 8.12975 16.8066 7.61165 16.6915L2.50582 15.5568C1.6117 15.3582 1.16464 15.2588 0.830929 15.0184C0.536581 14.8063 0.305454 14.5182 0.162299 14.1849C0 13.807 0 13.349 0 12.4331V2.99188Z",
    fill: "currentColor",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "maskBook",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 17
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.99188C0 1.96885 0 1.45734 0.211006 1.10279C0.39602 0.791917 0.68715 0.55838 1.03076 0.44521C1.42263 0.316141 1.92197 0.427104 2.92063 0.64903L7.95873 1.76861C8.34731 1.85496 8.5416 1.89813 8.73793 1.91535C8.91231 1.93064 9.08769 1.93064 9.26207 1.91535C9.4584 1.89813 9.65269 1.85496 10.0413 1.76861L15.0794 0.649029C16.078 0.427104 16.5774 0.316141 16.9692 0.44521C17.3128 0.55838 17.604 0.791917 17.789 1.10279C18 1.45734 18 1.96885 18 2.99188V12.4331C18 13.349 18 13.807 17.8377 14.1849C17.6945 14.5182 17.4634 14.8063 17.1691 15.0184C16.8354 15.2588 16.3883 15.3582 15.4942 15.5568L10.3884 16.6915C9.87025 16.8066 9.6112 16.8642 9.34942 16.8871C9.11692 16.9075 8.88308 16.9075 8.65058 16.8871C8.3888 16.8642 8.12975 16.8066 7.61165 16.6915L2.50582 15.5568C1.6117 15.3582 1.16464 15.2588 0.830929 15.0184C0.536581 14.8063 0.305454 14.5182 0.162299 14.1849C0 13.807 0 13.349 0 12.4331V2.99188Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#maskBook)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -1,
    width: 9,
    height: 19,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 9,
    height: 19,
    fill: "currentColor"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "book.5c1c2c02cf5ef0ca88d5bd7a76115caf.svg";